import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="app-footer">
      <p>
        Designed and Developed by{' '}
        <strong>Digital Applications Development Unit</strong>
        {' '}· BITS Pilani, Hyderabad Campus
      </p>
    </footer>
  );
}
